import { round } from './mathHelper';
/**
 * Числительные
 * @param {number} number кол-во
 * @param {Array<string>} titles ['секунда', 'секунды', 'секунд']
 * @returns {string}
 * @example declOfNum(5, ['секунда', 'секунды', 'секунд']); // returns 'секунд'
 */
export function declOfNum(number: number, titles: string[]) {
  const num = number;
  const cases = [2, 0, 1, 1, 1, 2];
  return titles[num % 100 > 4 && num % 100 < 20 ? 2 : cases[num % 10 < 5 ? num % 10 : 5]];
}

export function formatDistance(d: number) {
  if (!(d > 0)) {
    return '-';
  }
  return d > 1000 ? `${round(d / 1000, 2)}\u202fкм` : `${round(d, 0)}\u2009м`;
}

export function digitsDivision(num: number) {
  return num.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1\u00a0');
}

export function formatAltitude(d: number) {
  return `${digitsDivision(Math.round(d))}\u2009м`;
}

export function formatFinance(num: number, precision = 2, currencySymbol = '₽') {
  return `${digitsDivision(precision === 0 ? Math.ceil(num) : round(num, precision))}\u00a0${currencySymbol}`;
}
